// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { xBaseTheme } from "@steiner/XDL/types";
import { keyframes } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        transitions: {
            left: {
                enabled: true,
                length: 0,
                scrimEntryKeyframes: keyframes`
                    from { opacity: 0; }
                    to { opacity: 1; }
                `,
                scrimExitKeyframes: keyframes`
                    from { opacity: 1; }
                    to { opacity: 0; }
                `,
                overlayEntryKeyframes: keyframes`
                    from { margin-left: -100%; }
                    to { margin-left: 0; }
                `,
                overlayExitKeyframes: keyframes`
                    from { margin-left: 0; }
                    to { margin-left: -100%; }
                `,
            },
        },
    },
} as xBaseTheme["drawer"];
